import {NgModule} from '@angular/core';
import {FileViewerComponent} from './components/file-viewer/file-viewer.component';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {FileService} from '@ispm-client/modules/file-module/services/file.service';
import {SharedModule} from '@ispm/shared/shared.module';
import {CoreModule} from '@ispm/core/core.module';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {Mp4ViewerComponent} from "@ispm-client/modules/file-module/components/mp4-viewer/mp4-viewer.component";
import {GalleryViewerComponent} from "@ispm-client/modules/file-module/components/gallery-viewer/gallery-viewer.component";
import {MultiFileParsingService} from '@ispm-client/modules/file-module/services/multi-file-parsing.service';
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';

@NgModule({
  imports: [
    PdfJsViewerModule,
    SharedModule,
    CoreModule,
    FormsModule,
    CheckboxModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule
  ],
  providers: [FileService, MultiFileParsingService],
  declarations: [FileViewerComponent, Mp4ViewerComponent,GalleryViewerComponent],
  exports: [FileViewerComponent, Mp4ViewerComponent,GalleryViewerComponent]
})
export class FileModule { }
